'use client';

import { cn } from '@/lib/utils';
import { TextareaHTMLAttributes, forwardRef } from 'react';
import { FieldError, UseFormRegister } from 'react-hook-form';

interface CustomTextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    required?: boolean;
    className?: string;
    wrapperClassName?: string;
    register?: UseFormRegister<any>;
    error?: FieldError | string;
}

const Textarea = forwardRef<HTMLTextAreaElement, CustomTextareaProps>((props, ref) => {
    const { className, wrapperClassName, required, register, error, ...inputProps } =
        props;

    return (
        <div className={cn('flex flex-col', wrapperClassName)}>
            <textarea
                {...register}
                {...inputProps}
                ref={ref}
                className={cn(
                    'w-full border border-gray-300 px-6 lg:text-h5 max-lg:text-h6 font-bold text-black placeholder-gray-300/50 pt-3 focus:border-gray-300 focus:outline-none min-h-[72px] placeholder-shown:border-gray-300 bg-transparent rounded-none uppercase',
                    error && 'border-red',
                    className,
                )}
                placeholder={required ? `${inputProps.placeholder}*` : inputProps.placeholder}
                required={required}
            />
        </div>
    );
});

Textarea.displayName = 'Textarea';

export default Textarea;
